module.exports = __webpack_public_path__ + "img/pos.77abcff9.jpg";